export default "__VITE_ASSET__C5c6QVPi__"